import { useSyncExternalStore } from 'react';
import type { TCalendarColorBy } from '../types';

export const CALENDAR_COLOR_BY_STORAGE_KEY = 'borradh.calendar.colorBy.v1';
export const CALENDAR_COLOR_BY_OPTIONS = [
  { value: 'team-member', label: 'Team member' },
  { value: 'service', label: 'Service' },
] as const;
const listeners = new Set<() => void>();
let fallback: TCalendarColorBy = 'team-member';
let sessionOverride: TCalendarColorBy | undefined;

function readColorBy(): TCalendarColorBy {
  if (typeof window === 'undefined') return 'team-member';
  if (sessionOverride) return sessionOverride;
  try {
    return window.localStorage.getItem(CALENDAR_COLOR_BY_STORAGE_KEY) ===
      'service'
      ? 'service'
      : 'team-member';
  } catch {
    return fallback;
  }
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  window.addEventListener('storage', listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', listener);
  };
}

function setCalendarColorBy(value: TCalendarColorBy) {
  fallback = value;
  try {
    window.localStorage.setItem(CALENDAR_COLOR_BY_STORAGE_KEY, value);
    sessionOverride = undefined;
  } catch {
    // Keep the choice for this session when browser storage is unavailable.
    sessionOverride = value;
  }
  for (const listener of listeners) listener();
}

export function useCalendarColorBy() {
  const colorBy = useSyncExternalStore(
    subscribe,
    readColorBy,
    () => 'team-member' as const
  );
  return [colorBy, setCalendarColorBy] as const;
}
